import { VStack, HeadingText, SupportingText, Icon, Center } from '@common/components';

const SignUpHeader = () =>
(
    <VStack spacing="12px" textAlign="center">
        <Center bg="#F7FAFC" borderRadius="full" boxSize="56px">
            <Icon icon="check" color="#5A81A4" size="23px" />
        </Center>
        <HeadingText>Restablecer la contraseña</HeadingText>
        <SupportingText>Tu contraseña se ha restablecido con éxito. Haz clic a continuación para conectarte mágicamente.</SupportingText>
    </VStack>
);

export default SignUpHeader;